import { useEffect, useState } from "react"
import Frame from "../../Frames/Basic";
import { Stack, Alert, Button, Typography } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";
import API from "../../../services/API/Indents";
import Promo from "./Promo";
import Loader from "../../Tools/Loader";
import Tracker from "../../../services/Tracker"
import Invoice from "./Invoice";

export default function Success(){

    const {uuid, pin} = useParams()

    const [indent, setIndent] = useState(null)

    const [status, setStatus] = useState('loading')
    
    const statusIs = s => s === status
    const statusIsNot = s => s !== status

    useEffect(() => {

        const onSuccess = data => {

            console.log(data)

            setStatus('success')
            setIndent(data)

            Tracker.handleIndentValidation(data)
        }

        API.validate(uuid, pin)
            .then(r => onSuccess(r.data))
            .catch(e => setStatus(
                e.response?.status === 401 ? 'unauthorized' : 'error'
            ))
        

    }, [uuid, pin])


    const retry = () => {

        setStatus('loading')

        API.validate(uuid, pin)
            .then(r => setStatus('success'))
            .catch(e => setStatus('error'))
    }


    if(statusIs('redirect')) return <Navigate to="/" />


    return <Frame>

        <Stack direction='column' spacing={3} sx={{maxWidth: 600}}>

            <Typography variant='h2'>Validation de votre commande</Typography>

            {statusIs('loading') &&
                <Loader />
            }

            {statusIs('success') && <>

                <Alert severity='success'>
                    🎉 Félicitations ! Votre commande a bien été prise en compte. 
                </Alert>

                <Promo indent={indent} />

            </>}


            {statusIs('unauthorized') &&

                <Alert severity='error'>
                    Vous n'êtes pas autorisé à accéder à cette page.
                </Alert>
            }


            {statusIs('error') && <>

                <Alert severity='error'>
                    Une erreur s'est produite. Votre commande n'a pas été prise en compte.
                </Alert>

                <Button
                    variant='outlined'
                    onClick={retry}
                >
                    Réessayer
                </Button>
            
            </>}



            {statusIs('conflict') &&

                <Alert severity='success'>
                    🎉 Félicitations ! Votre commande a bien été prise en compte. 
                </Alert>
            }


            <Invoice indent={indent}/>
            


            {statusIsNot('loading') &&

               <Button variant='outlined' onClick={() => setStatus('redirect')}>
                    Retour à l'accueil
                </Button>
            }


        </Stack>

    </Frame>
}